module.exports = __webpack_public_path__ + "assets/Generic.892a2d88.svg";